export const SET_TOURNAMENT_STATUS_FOR_TOURNAMENT_STATUS = 'SET_TOURNAMENT_STATUS_FOR_TOURNAMENT_STATUS';
export const SET_TOURNAMENT_HAS_PENDING_CHANGES_FOR_TOURNAMENT_STATUS = 'SET_TOURNAMENT_HAS_PENDING_CHANGES_FOR_TOURNAMENT_STATUS';
export const SET_AVAILABLE_STATUSES_FOR_TOURNAMENT_STATUS = 'SET_AVAILABLE_STATUSES_FOR_TOURNAMENT_STATUS';
export const PUBLISH_STARTS_FOR_TOURNAMENT = 'PUBLISH_STARTS_FOR_TOURNAMENT';
export const PUBLISH_ENDS_FOR_TOURNAMENT = 'PUBLISH_ENDS_FOR_TOURNAMENT';
export const CANCEL_CONFIRM_MODAL_FOR_STATUS_CHANGE = 'CANCEL_CONFIRM_MODAL_FOR_STATUS_CHANGE';
export const DISPLAY_CONFIRM_MODAL_FOR_STATUS_CHANGE = 'DISPLAY_CONFIRM_MODAL_FOR_STATUS_CHANGE';
export const SET_EXPORT_SYSTEM_INFO = 'SET_EXPORT_SYSTEM_INFO';
export const LOADING_STARTS_FOR_TOURNAMENT = 'LOADING_STARTS_FOR_TOURNAMENT';
export const LOADING_ENDS_FOR_TOURNAMENT = 'LOADING_ENDS_FOR_TOURNAMENT';
export const SET_EXPORT_STATUS = 'SET_EXPORT_STATUS';



// WEBPACK FOOTER //
// ./src/features/tournament/status/constants.js